import { Api } from '@/api/api.client';
import type { Components } from '@/api/generated/api';

export async function fetchNoteById(params: { id: number }): Promise<Components.Schemas.NoteDto> {
  const res = await Api.Routes.Note.retrieveById({ id: params.id });
  return res.data;
}

export async function createNote(dto: Components.Schemas.CreateNoteDto): Promise<Components.Schemas.NoteDto> {
  const res = await Api.Routes.Note.create(null, dto);
  return res.data;
}

export async function updateNote(params: {
  id: number;
  dto: Components.Schemas.UpdateNoteDto;
}): Promise<Components.Schemas.NoteDto> {
  const res = await Api.Routes.Note.update({ id: params.id }, params.dto);
  return res.data;
}

export async function deleteNote(params: { id: number }): Promise<void> {
  await Api.Routes.Note.delete({ id: params.id });
}
